import { useCallback, useMemo } from "react";
import { type PropertySelectionRow } from "../../types";

interface UsePropertySelectionProps {
  selectedProperties: PropertySelectionRow[];
  setSelectedProperties: React.Dispatch<
    React.SetStateAction<PropertySelectionRow[]>
  >;
}

/**
 * プロパティ選択機能を管理するカスタムフック
 */
export const usePropertySelection = ({
  selectedProperties,
  setSelectedProperties,
}: UsePropertySelectionProps): {
  handleDelete: (id: number) => void;
  selectedItems: PropertySelectionRow[];
} => {
  /**
   * 指定されたIDのプロパティの選択状態を解除します。
   * @param id - 選択解除するプロパティのID
   */
  const handleDelete = useCallback(
    (id: number) => {
      setSelectedProperties((prevProperties) =>
        prevProperties.map((prop) =>
          prop.id === id ? { ...prop, selected: false } : prop
        )
      );
    },
    [setSelectedProperties]
  );

  /**
   * 選択済みのプロパティのみを返します。
   */
  const selectedItems = useMemo(
    () => selectedProperties.filter((prop) => prop.selected),
    [selectedProperties]
  );

  return {
    handleDelete,
    selectedItems,
  };
};
